import React, { createContext, useState, useEffect, useCallback } from 'react';
import { getBaseUrl } from '../utils/apiUtils';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check authentication status - using useCallback to memoize the function
  const checkAuthStatus = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch(`${getBaseUrl()}/api/user`, {
        credentials: 'include' // Important for sending cookies
      });
      const data = await response.json();
      
      if (data.isAuthenticated) {
        setUser(data.user);
        setIsAuthenticated(true);
      } else {
        setUser(null);
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('Error checking authentication status:', error);
      setUser(null);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }, []);

  // Save username to server
  const saveUsernameToServer = async (username) => {
    if (!isAuthenticated || !username) return false;
    
    try {
      const response = await fetch(`${getBaseUrl()}/api/user/username`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include', // Important for sending cookies
        body: JSON.stringify({ username })
      });
      
      const data = await response.json();
      
      if (data.success) {
        console.log('Username saved to server successfully');
        // Update the user object with the new username
        setUser(prevUser => ({
          ...prevUser,
          selectedUsername: username
        }));
        return true;
      } else {
        console.error('Error saving username to server:', data.message);
        return false;
      }
    } catch (error) {
      console.error('Error saving username to server:', error);
      return false;
    }
  };

  // Login function
  const login = () => {
    window.location.href = `${getBaseUrl()}/auth/google`;
  };

  // Logout function
  const logout = () => {
    window.location.href = `${getBaseUrl()}/auth/logout`;
  };

  // Check auth status on component mount
  useEffect(() => {
    checkAuthStatus();
  }, [checkAuthStatus]);

  return (
    <AuthContext.Provider 
      value={{ 
        isAuthenticated, 
        user, 
        loading,
        login,
        logout,
        checkAuthStatus,
        saveUsernameToServer
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;